import { Injectable } from '@angular/core';
import { AreaBarcodeFormat } from './area';

@Injectable()
export class LocationLogicService {

  constructor() { }

  /**
   * Parses barcode format to gather information on which parts are 
   * included and how many positions they have.
   * 
   * @param pBarcodeformat 
   */
  public parseBarcodeElements(pBarcodeformat: string): AreaBarcodeFormat {
    let barcodeformat: AreaBarcodeFormat = new AreaBarcodeFormat();
    if (pBarcodeformat != null) {
      if (pBarcodeformat.includes(barcodeformat.p_area)) {
        barcodeformat.area = true;
        barcodeformat.l_area = (pBarcodeformat.match(new RegExp(barcodeformat.p_area, 'g')) || []).length;
      }
      if (pBarcodeformat.includes(barcodeformat.p_rack)) {
        barcodeformat.rack = true;
        barcodeformat.l_rack = (pBarcodeformat.match(new RegExp(barcodeformat.p_rack, 'g')) || []).length;
      }
      if (pBarcodeformat.includes(barcodeformat.p_tray)) {
        barcodeformat.tray = true;
        barcodeformat.l_tray = (pBarcodeformat.match(new RegExp(barcodeformat.p_tray, 'g')) || []).length;
      }
      if (pBarcodeformat.includes(barcodeformat.p_level)) {
        barcodeformat.level = true;
        barcodeformat.l_level = (pBarcodeformat.match(new RegExp(barcodeformat.p_level, 'g')) || []).length;
      }
    }
    return barcodeformat;
  }

  /**
   * Checks if the given format has at least one of character which is 
   * a template placeholder and can be replaced by an incrementing number.
   * 
   * @param pBarcodeformat 
   */
  public isLocationFormatValid(pBarcodeformat: string): boolean {
    let barcodeformat: AreaBarcodeFormat = new AreaBarcodeFormat();
    let isValid: boolean = false;
    if (pBarcodeformat != null) {
      if (pBarcodeformat.includes(barcodeformat.p_area)) {
        isValid = true;
      }
      if (pBarcodeformat.includes(barcodeformat.p_rack)) {
        isValid = true;
      }
      if (pBarcodeformat.includes(barcodeformat.p_tray)) {
        isValid = true;
      }
      if (pBarcodeformat.includes(barcodeformat.p_level)) {
        isValid = true;
      }
    }

    return isValid;
  }

  /**
   * Adds as many leading zeros to string as reqired to represend number
   * in correct format.
   * @param pNumber 
   * @param pDigits 
   */
  private formatStringWithLeadingZeros(pNumber: string, pDigits: number): string {
    let strNumber: string = pNumber + "";
    let numberOfLeadingZeros: number = 0;

    if (pDigits == null)
      pDigits = 0;

    if (strNumber == null || strNumber.length == 0) {
      numberOfLeadingZeros = pDigits;
      strNumber = "";
    }else{
      numberOfLeadingZeros = pDigits - strNumber.length;
    }

    for (var i = 0; i < numberOfLeadingZeros; i++) {
      strNumber = "0"+strNumber;
    }

    return strNumber;
  }

  public formatArea(pArea : string, pBarcodeformat: AreaBarcodeFormat) : string {
    return this.formatStringWithLeadingZeros(pArea, pBarcodeformat.l_area);
  }

  public formatRack(pRack : string, pBarcodeformat: AreaBarcodeFormat) : string {
    return this.formatStringWithLeadingZeros(pRack, pBarcodeformat.l_rack);
  }

  public formatTray(pTray : string, pBarcodeformat: AreaBarcodeFormat) : string {
    return this.formatStringWithLeadingZeros(pTray, pBarcodeformat.l_tray);
  }

  public formatLevel(pLevel : string, pBarcodeformat: AreaBarcodeFormat) : string {
    return this.formatStringWithLeadingZeros(pLevel, pBarcodeformat.l_level);
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/location/location-logic.service.ts